// global
import React, { Component } from 'react';
import { Popup, Icon, Label } from 'semantic-ui-react';

const Content = () => {
    return (
        <div>
            A senha deve conter no mínimo <strong>8 caracteres</strong> compostos por <strong>letras (no mínimo uma letra Maiusculas)</strong> e
            <strong>números</strong>, ex: <Label>S3nhaF0rt3</Label>.
        </div>
    );
};

class PasswordLabel extends Component {
    render() {
        return (
            <React.Fragment>
                Senha <Popup trigger={<Icon fitted name="info circle" color="red" inverted />} content={<Content />} />
            </React.Fragment>
        );
    }
}

export default PasswordLabel;
